// extracted by mini-css-extract-plugin
export default {"categories-links":"c5dfH"};